<template>
    <div class="page page--light page-rewards page--gradient-background">
        <section class="row main">
            <div class="wrapper">
                <toggle-options :options.sync="toggleOptions"
                    class="toggle-options"
                    @toggleOption="onToggled"
                />
                <router-view />
            </div>
        </section>
    </div>
</template>

<script>
// Components
import toggleOptions from '@webapp/components/status-toggle/status-toggle.vue';
import {
    RewardsRemoteConfigKeys,
} from '@shared/modules/rewards/types/constants';

// Store
import {
    mapGetters,
} from 'vuex';

export default {
    name: 'rewards',
    components: {
        toggleOptions,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            // Redirect to 404 if disabled
            if (!vm.remoteConfigByKey(RewardsRemoteConfigKeys.IsWebAchievementsEnabled)) {
                next('/404');
            }
        });
    },
    data() {
        return {
            toggleOptions: [
                {
                    name: this.$t('rewards.badgesTitle'),
                    isDisabled: false,
                    path: 'badges',
                },
                {
                    name: this.$t('rewards.leaderboardTitle'),
                    isDisabled: false,
                    path: 'leaderboards',
                },
            ],
        };
    },
    computed: {
        ...mapGetters('remoteConfig', ['remoteConfigByKey']),
    },
    methods: {
        onToggled(options) {
            this.$router.replace(options.find((item) => item.isSelected).path);
        },
    },
};
</script>

<style lang="scss" scoped>
.page-rewards {
    padding-bottom: 6.5rem;

    @include min-width(md) {
        padding-bottom: 0;
    }
}

.toggle-options {
    margin-top: 2.6rem;
}
</style>